export const w2Keys = {
  workStatusSummary: ['w2', 'work-status-summary'] as const,
  pendingPayments: ['w2', 'pending-payments'] as const,
  itemsInReview: ['w2', 'items-in-review'] as const,
}
